import config from "@/config.json";

const { collection } = config;

const SEARCH = "https://api-read.transkribus.eu";
const CONTENT = "https://api-content.transkribus.eu";
// const SEARCH = "http://localhost:4321";

const CONTENT_TYPE = "application/json; charset=utf-8";

export default {
  async fetchDocuments({ offset = 0, limit = 100 } = {}) {
    const res = await fetch(`${SEARCH}/documents`, {
      method: "POST",
      body: JSON.stringify({
        collections: [collection],
        offset,
        limit,
      }),
      headers: {
        "Content-Type": CONTENT_TYPE,
        Accept: CONTENT_TYPE,
      },
    });
    const data = await res.json();
    return data;
  },
  async fetchDocument(id) {
    const res = await fetch(`${SEARCH}/documents/${id}`, {
      method: "GET",
    });
    return await res.json();
  },
  async fetchDocumentPages(id, { offset = 0, limit = 100 } = {}) {
    try {
      const res = await fetch(`${SEARCH}/documents/${id}/pages/`, {
        method: "POST",
        body: JSON.stringify({
          offset,
          limit,
        }),
        headers: {
          "Content-Type": CONTENT_TYPE,
          Accept: CONTENT_TYPE,
        },
      });
      return await res.json();
    } catch (err) {
      console.error(err);
    }
  },
  async fetchPageByNum({ id, pageNum }) {
    try {
      const res = await fetch(`${SEARCH}/documents/${id}/pages/${pageNum}`, {
        method: "GET",
      });
      return await res.json();
    } catch (err) {
      console.error(err);
    }
  },
  async fetchSearchResults(
    { term, documents, titles, page, fuzziness },
    { offset = 0, limit = 10 },
  ) {
    const res = await fetch(`${SEARCH}/search`, {
      method: "POST",
      body: JSON.stringify({
        term,
        collections: [collection],
        documents,
        titles,
        page,
        fuzziness,
        offset,
        limit,
      }),
      headers: {
        "Content-Type": CONTENT_TYPE,
        Accept: CONTENT_TYPE,
      },
    });
    if (res.status === 200) {
      const data = await res.json();
      const { total, results } = data;
      return {
        total,
        results,
      };
    } else {
      const { message } = await res.json();
      throw new Error(`${res.status}: ${message}`);
    }
  },
  async fetchTagResults(
    { value, type, facets, facetValues } = {},
    { offset = 0, limit = 10 } = {},
  ) {
    const res = await fetch(`${SEARCH}/tags`, {
      method: "POST",
      body: JSON.stringify({
        value,
        type,
        facets,
        facetValues,
        collections: [collection],
        offset,
        limit,
      }),
      headers: {
        "Content-Type": CONTENT_TYPE,
        Accept: CONTENT_TYPE,
      },
    });
    if (res.status === 200) {
      const data = await res.json();
      console.log(data);
      const { total, results, facets } = data;
      return {
        total,
        results,
        facets,
      };
    } else {
      const { message } = await res.json();
      throw new Error(`${res.status}: ${message}`);
    }
  },
  async fetchSearchFacets({ term, documents, titles, fuzziness }) {
    const res = await fetch(`${SEARCH}/facets`, {
      method: "POST",
      body: JSON.stringify({
        term,
        collections: [collection],
        documents,
        titles,
        fuzziness,
      }),
      headers: {
        "Content-Type": CONTENT_TYPE,
        Accept: CONTENT_TYPE,
      },
    });
    const data = await res.json();
    const { total, facets, params } = data;
    return {
      total,
      facets,
      params,
    };
  },
  async fetchPageContent(url) {
    console.log("fetchPageContent");
    console.log(url);
    const res = await fetch(url);
    return await res.text();
  },
  async fetchContent(id) {
    const res = await fetch(`${CONTENT}/content/${id}`);
    if (res.status === 200) return res.json();
    return null;
  },
  async sendMail(to, from, subject, text) {
    const res = await fetch("https://app.transkribus.eu/api/v1/send-email", {
      method: "POST",
      body: JSON.stringify({
        to,
        from,
        subject,
        text,
      }),
      headers: {
        "Content-Type": CONTENT_TYPE,
        Accept: CONTENT_TYPE,
      },
    });
    if (res.status === 200) return res.json();
    return null;
  },
};
